module.exports = __webpack_public_path__ + "static/img/twjd-sdh1.02fbbeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdh1.png
// module id = 846
// module chunks = 0